import { NodeType } from "../Models/NodeType";

import PlaceholderNode from "./Placeholder";
import WebhookTriggerNode from "./WebhookTrigger";
import AssistantNode from "./Assistant";
import ConditionalNode from "./Conditional";
import ExternalApiNode from "./ExternalApi";
import EndNode from "./End";
import WaitForCallbackNode from "./WaitForCallback";
import DelayNode from "./Delay";

export const nodeTypes = {
  placeholder: PlaceholderNode,
  [NodeType.WEBHOOK_TRIGGER]: WebhookTriggerNode,
  [NodeType.ASSISTANT]: AssistantNode,
  [NodeType.CONDITIONAL]: ConditionalNode,
  [NodeType.EXTERNAL_API]: ExternalApiNode,
  [NodeType.END]: EndNode,
  [NodeType.WAIT_FOR_CALLBACK]: WaitForCallbackNode,
  [NodeType.DELAY]: DelayNode,
} as const;
